import axiosInstance from '../axios/axiosInstance';

export const createPlaidLinkToken = async (userId) => {
    const res = await axiosInstance.post(`/plaid/link-token?userId=${encodeURIComponent(userId)}`);
    return res.data.linkToken;
};

export const exchangePlaidToken = async ({ publicToken, bankAccountId, ownerId, ownerType, companyId }) => {
    const res = await axiosInstance.post('/plaid/exchange', {
        publicToken,
        bankAccountId,
        ownerId,
        ownerType,
        companyId,
    });
    return res.data;
};
